import request from '@/utils/request'

export function getExam(data) { //获取答题列表
  return request({
    url: '/index/question/getexam',
    method: 'post',
    data
  })
}

export function mark(data) {  //提交答题
    return request({
      url: '/index/question/mark',
      method: 'post',
      data
    })
  }

  export function getMark(data) {  //获取答题分数
    return request({
      url: '/index/question/getMark',
      method: 'post',
      data
    })
  }
